import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import ContactAvatar from '$tablet-app/src/app/components/Contact/ContactAvatar';
import Text from '$tablet-app/src/app/components/Text';
import { hasImage } from '@akin-home/images';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import Spacer from '../../components/Spacer';

interface DashboardProfileProps {
  user: UserModel;
}

const DashboardProfile: FC<DashboardProfileProps> = ({ user }) => (
  <Row>
    {hasImage(user) ? <Image contact={user} /> : <Spacer width="10px" />}

    <Text weight="bold">Hi {user.name}</Text>
  </Row>
);

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 17px;
`;

const Image = styled(ContactAvatar)`
  height: 45px;
  width: 45px;
`;

export default DashboardProfile;
